import {useContext} from "react";
import {FaTriangleExclamation} from "react-icons/fa6";

import {Alert} from "@/components/alert/Alert.tsx";
import Button from "@/components/button/Button.tsx";
import {TabContext} from "@/lib/hooks/useTabs.tsx";
import {StatusPage, SubscriptionType} from "@/lib/types/statuspages.ts";

interface DisabledNotificationsWarningPanelProps {
  statusPage: StatusPage;
  selectedTab: string;
  handleClick?: () => void;
}

export const DisabledNotificationsWarningPanel = ({
  statusPage,
  selectedTab,
  handleClick,
}: DisabledNotificationsWarningPanelProps) => {
  const {changeTab} = useContext(TabContext);

  const onClick = () => {
    if (handleClick) handleClick();
    else changeTab("privacy");
  };

  const allowNotifications = statusPage.allow_notifications;

  const type = selectedTab[0] + selectedTab.slice(1, selectedTab.length).toLowerCase();
  const subscriptionReason = `${type} subscriptions are disabled. Reactivate ${type} channel to allow subscription via ${type}.`;

  let allowNotificationReason = `Notifications are enabled. Existing subscribers will receive notifications.`;

  if (!allowNotifications) {
    allowNotificationReason = `Notifications are disabled. Reactivate notifications to send notifications to users.`;
  }

  const subscriptionCondition =
    (selectedTab === SubscriptionType.EMAIL && !statusPage.allow_subscriptions_email) ||
    (selectedTab === SubscriptionType.SMS && !statusPage.allow_subscriptions_sms) ||
    (selectedTab === SubscriptionType.WEBHOOK && !statusPage.allow_subscriptions_webhook) ||
    (selectedTab === SubscriptionType.SLACK && !statusPage.allow_subscriptions_slack);

  if (!allowNotifications || subscriptionCondition) {
    return (
      <Alert variant={"maintenance"} className={"align-items-center"} icon={FaTriangleExclamation}>
        <div className={"d-flex align-items-center justify-content-between"}>
          <div className={"d-flex flex-column gap-1"}>
            {subscriptionCondition && <span>{subscriptionReason}</span>}
            <span>{allowNotificationReason}</span>
          </div>
          <Button className={"testColumn"} onClick={() => onClick()}>
            Reactivate Now
          </Button>
        </div>
      </Alert>
    );
  }
  return false;
};
